export type ForceLogoutAuthErrorRule = {
    status: number;
    message: string;
};

/** Chyby, při kterých MyS automaticky odhlásí uživatele. */
export const FORCE_LOGOUT_AUTH_ERRORS: readonly ForceLogoutAuthErrorRule[] = [
    { status: 401, message: 'AUTH_ACCESS_DENIED_WITHOUT_KEY' },
    { status: 401, message: 'Missing authentication' },
    // budoucí rozšíření např.:
    // { status: 403, message: 'Insufficient scope' },
] as const;
